import React from 'react';
import "./Footer.css";

const Footer = () => {
  return (
    <div className='footer'>
        <p>© 2024 Wardiere University. All Rights Reserved Waleed Ahmed</p>
        <ul>
            <li>Privacy Policy</li>
            <li>Terms of Services</li>
        </ul>
    </div>
  )
}

export default Footer